import React from "react";
import logger from "logger";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

export default class Component extends React.Component {
  constructor(props) {
    super();
  }

  render = () => {
    const props = this.props;

    logger.log("props", props);

    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={props.value}
            disabled={props.disabled}
            onChange={() => {
              props.onChange();
            }}
            style={{ paddingLeft: "0px" }}
          />
        }
        label={props.children}
        style={{
          width: "100%",
          marginLeft: "0px",
          paddingLeft: "0px",
        }}
      />
    );
  };
}
